export enum ProcessActionAllowedAction {
  GO_BACK = 'goBack',
  CANCEL = 'cancel',
  ADD_BANK_ACCOUNT = 'addBankAccount'
}
